import React, { FunctionComponent } from 'react';
import useLineItems from './useLineItems';
import LineItem from '~/hooks/useQuoteDownload/Render/LineItems/LineItem';

const LineItems: FunctionComponent = function () {
  const { lineItems } = useLineItems();

  return (
    <>
      {lineItems.map((lineItem) => (
        <LineItem key={lineItem.key} lineItem={lineItem} />
      ))}
    </>
  );
};

export default LineItems;
